"use client"

import { ArrowUpFromDot } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `ArrowUpFromDotIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const ArrowUpFromDotIcon = component(Icon)({ as: ArrowUpFromDot })
